import { render, staticRenderFns } from "./HeaderNotifications.vue?vue&type=template&id=4660dbd1&"
import script from "./HeaderNotifications.vue?vue&type=script&lang=js&"
export * from "./HeaderNotifications.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
